import React from 'react'
import { useRouteMatch } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import { PageHeader } from 'components/page-header'
import AvailabilityManager from './availability-manager'
import AvailabilityTab from './availability-tab'
import { makeStyles } from '@material-ui/styles'
import { flags, useFeatureFlags } from 'lib/feature-flags'
import { usePortal } from 'lib/portal'

export const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(7),
    [theme.breakpoints.only('xs')]: {
      margin: '16px 16px 96px 16px',
    },
  },
  customRoot: {
    margin: theme.spacing(7),
    marginTop: theme.spacing(3),
    [theme.breakpoints.only('xs')]: {
      margin: '8px 16px 96px 16px',
    },
  },
}))

const AvailabilityPage = () => {
  const classes = useStyles()
  const { path } = useRouteMatch()
  const [isCustomAvailabilityEnabled] = useFeatureFlags([
    flags.FLAG_CUSTOM_AVAILABILITY,
  ])
  const [HeaderActionsPortal, headerActionsTarget] = usePortal()

  const crumbs = [
    {
      label: 'Settings',
      to: path
        .split('/')
        .slice(0, 3)
        .join('/'),
    },
  ]

  if (!isCustomAvailabilityEnabled) {
    return (
      <>
        <PageHeader title="Availability" crumbs={crumbs} />
        <Box className={classes.root}>
          <Grid container>
            <Grid item xs={12}>
              <AvailabilityManager />
            </Grid>
          </Grid>
        </Box>
      </>
    )
  }

  return (
    <>
      <PageHeader
        title="Availability Settings"
        crumbs={crumbs}
        actions={headerActionsTarget}
      />
      <Box className={classes.customRoot}>
        <AvailabilityTab HeaderActionsPortal={HeaderActionsPortal} />
      </Box>
    </>
  )
}

export default AvailabilityPage
